import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { useSiteImages, pick } from "@/lib/siteImages";

const posts = [
  "https://images.pexels.com/photos/14509757/pexels-photo-14509757.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/29193428/pexels-photo-29193428.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/31605845/pexels-photo-31605845.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/13292930/pexels-photo-13292930.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

const IG_URL = "https://www.instagram.com/ma.vi_gioielli";

export default function InstagramSection() {
  const siteImgs = useSiteImages();
  return (
    <section id="instagram" className="py-28 lg:py-36 bg-[#FDF8F7]" data-testid="instagram-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14"
        >
          <div className="max-w-xl">
            <span className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C4758A]" data-testid="instagram-overline">
              @ma.vi_gioielli
            </span>
            <h2 className="font-serif-display text-4xl sm:text-5xl mt-4 text-[#37282B]" data-testid="instagram-headline">
              Seguici nel <span className="italic text-[#E2A3B1]">laboratorio</span>
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#6B5459]">
              Retroscena della lavorazione, nuove creazioni e storie delle famiglie che ci scelgono.
            </p>
          </div>
          <a
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-button"
            className="group inline-flex items-center gap-3 px-7 py-3.5 border border-[#37282B]/20 rounded-full text-xs uppercase tracking-[0.2em] font-semibold text-[#37282B] hover:border-[#E2A3B1] hover:text-[#C4758A] transition-colors duration-300 shrink-0"
          >
            <Instagram className="w-4 h-4" />
            Segui @ma.vi_gioielli
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {posts.map((src, i) => (
            <motion.a
              key={i}
              href={IG_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`group relative rounded-2xl overflow-hidden aspect-square bg-[#FBECEA] ${i % 2 === 1 ? "lg:mt-8" : ""}`}
              data-testid={`instagram-post-${i}`}
            >
              <img
                src={pick(siteImgs, `instagram_${i + 1}`, src)}
                alt={`Creazione Ma.Vi Gioielli ${i + 1}`}
                className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#37282B]/0 group-hover:bg-[#37282B]/45 transition-colors duration-500 flex items-center justify-center">
                <Instagram className="w-8 h-8 text-[#FDF8F7] opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-[opacity,transform] duration-400" strokeWidth={1.5} />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
